import { z } from 'zod';
import { Device, deviceSchema, mockDevice } from 'app/agriculture/queries/devices/types/Device';

export interface GasbotDevice extends Device {
    deviceType: 'Level Monitor';
    brand: 'Gasbot';
}

export const gasbotDeviceSchema = deviceSchema.extend({
    brand: z.literal('Gasbot'),
    deviceType: z.literal('Level Monitor'),
});

export const mockGasbotDevice = ({
    brand = 'Gasbot',
    deviceType = 'Level Monitor',
    id = 'b2393bf5-3a58-4ab5-bd66-0a344cb2202e',
    ...device
}: Partial<GasbotDevice> = {}): GasbotDevice => ({
    ...mockDevice(device),
    id,
    brand,
    deviceType,
});
